import styled from 'styled-components/macro';
import { useState } from 'react';
import { ResetStyle } from './styles/resetStyle';
import { GlobalStyle } from 'src/styles/globalStyle';
import SkipLink from 'src/components/ui-kit/SkipLink';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Home from 'src/components/contents/home/Home';
import Header from 'src/components/layout/header/Header';
import Footer from 'src/components/layout/footer/Footer';
import PatentRights from 'src/components/contents/search/PatentRights';
import TrademarkRights from 'src/components/contents/search/TrademarkRights';
import MobileMenu from './components/layout/header/MobileMenu';
import ModalLayout from './components/layout/modal/ModalLayout';
import PatentResult from './components/contents/search/result/PatentResult';
import TmarkResult from './components/contents/search/result/TmarkResult';
import PatentDetail from './components/contents/detail/patentDetail/PatentDetail';
import TmarkDetail from './components/contents/detail/tmarkDetail/TmarkDetail';
import CertVerify from './components/contents/certification/verify/CertVerify';
import CertDownload from './components/contents/certification/download/CertDownload';
import PatentDirection from './components/contents/direction/patent/PatentDirection';
import TmarkDirection from './components/contents/direction/tmark/TmarkDirection';
import CertDirection from './components/contents/direction/cert/CertDirection';
import QRCodeDirection from './components/contents/direction/qrCode/QRCodeDirection';
import Sitemap from 'src/components/contents/home/Sitemap';
import TagManager from 'react-gtm-module';

const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-flow: column;
`;

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID ? process.env.REACT_APP_GTM_ID : '',
  auth: process.env.REACT_APP_GTM_AUTH ? process.env.REACT_APP_GTM_AUTH : '',
  preview: process.env.REACT_APP_GTM_PREVIEW ? process.env.REACT_APP_GTM_PREVIEW : '',
  dataLayer: {
    envManual: process.env.REACT_APP_GTM_PREVIEW,
  },
};

TagManager.initialize(tagManagerArgs);

function App() {
  const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);

  return (
    <BrowserRouter>
	  <ResetStyle />
      <GlobalStyle />
	  <SkipLink />
      <Container>
        <Header setMobileMenuIsOpen={setMobileMenuIsOpen} />
        <MobileMenu isOpen={mobileMenuIsOpen} onClose={() => setMobileMenuIsOpen(false)} />
		<main id="main-content" tabIndex={-1} style={{ flex: 1, outline: 'none' }}>
        <Routes>
          <Route path={process.env.PUBLIC_URL + "/"} element={<Home />} />
          <Route path={process.env.PUBLIC_URL + "/patentRights"} element={<PatentRights />} />
          <Route path={process.env.PUBLIC_URL + "/trademarkRights"} element={<TrademarkRights />} />
          <Route path={process.env.PUBLIC_URL + "/patentRights/result"} element={<PatentResult />} />
          <Route path={process.env.PUBLIC_URL + "/patentRights/detail"} element={<PatentDetail />} />
          <Route path={process.env.PUBLIC_URL + "/trademarkRights/result"} element={<TmarkResult />} />
          <Route path={process.env.PUBLIC_URL + "/trademarkRights/detail"} element={<TmarkDetail />} />
          <Route path={process.env.PUBLIC_URL + "/certificate/verify"} element={<CertVerify />} />
          <Route path={process.env.PUBLIC_URL + "/certificate/download"} element={<CertDownload />} />
          <Route path={process.env.PUBLIC_URL + "/patentRights/direction"} element={<PatentDirection />} />
          <Route path={process.env.PUBLIC_URL + "/trademarkRights/direction"} element={<TmarkDirection />} />
          <Route path={process.env.PUBLIC_URL + "/certificate/direction"} element={<CertDirection />} />
          <Route path={process.env.PUBLIC_URL + "/qrcode/direction"} element={<QRCodeDirection />} />
		  <Route path={process.env.PUBLIC_URL + "/sitemap"} element={<Sitemap />} />
          <Route path={process.env.PUBLIC_URL + "*"} element={<Navigate to="/" />} />
        </Routes>
		</main>
        <Footer />
      </Container>
      <ModalLayout />
    </BrowserRouter>
  );
}

export default App;
